export const LOGO_URL = {
  1: "/images/logo-tap.png",
  2: "/images/logo-tpr.png",
  8: "/images/logo-profi.png",
  9: "/images/logo-elita.svg",
  5: "/images/logo-sad.png",
  4: "/images/logo-wiom.png",
  11: "/images/logo-smartwies.png",
};
